module.exports = __webpack_public_path__ + "img/gs.d3bf148d.svg";